<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    enable-background="new 0 0 24 24"
    viewBox="0 0 24 24"
    width="24px"
    height="24px"
    fill="currentcolor"
  >
    <g>
      <rect fill="none" height="24" width="24" x="0" />
      <polygon points="14.43,10 12,2 9.57,10 2,10 8.18,14.41 5.83,22 12,17.31 18.18,22 15.83,14.41 22,10" />
    </g>
  </svg>
</template>

<script>
export default {};
</script>
